export default "__VITE_ASSET__BtryQO68__"